import React from "react";
import '../howworks/howwork.css';
import { useTranslation } from "react-i18next";

const Howwork = () => {
    const { t } = useTranslation();

    return (
        <div>
            <section className="how" id="request">
                <div className="container">
                    {/* <div className="services-title">
                        <h5 className="sub-title">How We Works</h5>
                        <h3 className="title how-title">Get your insurance easy online
                            &amp; just in few minutes</h3>
                        <p>We use technology to serve you better, save your time, less paperwork and gives you more options.</p>
                    </div>
                    <div className="row pt-4 align-items-center">
                        <div className="col-md-12 col-lg-6">
                            <div className="how-img">
                                <img src={require("../../assets/images/we-work.png")} alt="img" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-6">
                            <div className="how-list">
                                <ul>
                                    <li className="green">
                                        <div className="icon">
                                            <h3>01</h3>
                                        </div>
                                        <div className="content">
                                            <h5>Enter Your Information</h5>
                                            <p>Start by providing some basic information about yourself and the type of coverage
                                                you're looking for. Don't worry, we take your privacy seriously and will only
                                                use your information to generate accurate quotes.</p>
                                        </div>
                                    </li>
                                    <li className="purple">
                                        <div className="icon">
                                            <h3>02</h3>
                                        </div>
                                        <div className="content">
                                            <h5>Compare Quotes</h5>
                                            <p>Once you've entered your information, you'll instantly receive quotes from
                                                multiple insurance providers tailored to your specific needs. You can compare
                                                coverage options, prices, and policy details to find the best fit for you.</p>
                                        </div>
                                    </li>
                                    <li className="red">
                                        <div className="icon ">
                                            <h3>03</h3>
                                        </div>
                                        <div className="content">
                                            <h5>Choose Your Coverage</h5>
                                            <p>After reviewing your quotes, you can choose the policy that best meets your needs
                                                and budget. Once you've made your selection, you can purchase your policy
                                                directly through our website.</p>
                                        </div>
                                    </li>
                                    <li className="yellow">
                                        <div className="icon">
                                            <h3>04</h3>
                                        </div>
                                        <div className="content">
                                            <h5>Enjoy Peace of Mind</h5>
                                            <p>With your new insurance policy in place, you can rest easy knowing that you're
                                                protected against life's unexpected events. And if your needs change in the
                                                future, you can always come back to Suq Al Tamin to compare quotes again. </p>
                                        </div>
                                    </li>
                                </ul>
                                <div className="next-btn">
                                    <button type="button" className="btn btn-blue">Get Started</button>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="row">
                        <div className="col-md-12 col-lg-6">
                            <h3 >{t('howWeWork.title')}</h3>
                            <ul>
                                <li>
                                    <div className="nuber-box">1</div>
                                    <div><h4>{t('howWeWork.steps.card1.title1')}</h4><h4>{t('howWeWork.steps.card1.title2')}</h4></div>
                                </li>
                                <li>
                                    <div className="nuber-box">2</div>
                                    <div><h4>{t('howWeWork.steps.card2.title1')}</h4><h4>{t('howWeWork.steps.card2.title2')}</h4></div>
                                </li>
                                <li>
                                    <div className="nuber-box">3</div>
                                    <div><h4>{t('howWeWork.steps.card3.title1')}</h4><h4>{t('howWeWork.steps.card3.title2')}</h4></div>
                                </li>
                                <li>
                                    <div className="nuber-box">4</div>
                                    <div><h4>{t('howWeWork.steps.card4.title1')}</h4><h4>{t('howWeWork.steps.card4.title2')}</h4></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="work-image">
                        <img src={require("../../assets/images/how-work.png")} alt="img" className="img-fluid" />
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Howwork;